export function getTelegramUser() {
  try {
    const tg = window.Telegram?.WebApp;
    const user = tg?.initDataUnsafe?.user;
    if (!user) return null;

    return {
      telegram_id: user.id,
      full_name: user.first_name || "",
      username: user.username || "",
    };
  } catch (e) {
    console.warn("Telegram auth error:", e);
    return null;
  }
}
